import { PLAN_READINESS_LEVELS, READINESS_SCORE_BAR_COUNT } from './constants';
import { getVariantColor } from './utils';
export default {
    name: 'ReadinessBar',
    props: {
        readinessLevel: {
            type: Object,
            required: true,
            validator: (value)=>Object.keys(PLAN_READINESS_LEVELS).includes(value.value)
        },
        ariaLabel: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        pillBgClass () {
            return getVariantColor(this.readinessLevel.variant);
        },
        pillStyle () {
            const { barsToFill } = this.readinessLevel;
            return {
                width: `${barsToFill / READINESS_SCORE_BAR_COUNT * 100}%`,
                backgroundColor: this.pillBgClass
            };
        }
    }
};
